import { DialogTitle, styled } from '@mui/material';

export const StyledDialogTitle = styled(DialogTitle)`
  background-color: whitesmoke;
`;
